import { BaseDataTransferObject } from '../../../shared/models/base-data-transfer-object';
import { BillingInformation } from '../../../shared/models/billing/billing-information';
import { PatientEditable } from '../../../shared/models/order-entry/patient';
import { Physician } from '../../../shared/models/order-entry/physician';
import { ResponsibleParty } from '../../../shared/models/order-entry/reponsible-party';

export class OrderBillingInformation extends BaseDataTransferObject {
    public orderCode?: string;
    public patientLastName?: string;
    public patientFirstName?: string;
    public orderEntryAlert?: string;
    public patient?: PatientEditable;
    public diagnoses?: number[];
    public physician?: Physician;
}

export class OrderBillingInformationEditable extends BaseDataTransferObject {
    public orderId?: number;
    public patientId?: number;
    public birthDate?: Date;
    public gender?: string;
    public physicianId?: number;
    public diagnoses?: number[];
    public insuranceInformation?: BillingInformation[];
    public responsibleParties?: ResponsibleParty[];
    public comments?: string;
    public username?: string;
}
